<script setup>
import Products from '@/components/Products.vue';
</script>

<script>
// normal `<script>`, executed in module scope (only once)
// declare additional options
export default {
  inheritAttrs: false,
  customOptions: {},
};
</script>

<template>
  <Products />
</template>
